import { render, staticRenderFns } from "./InfiniteScrollDetector.vue?vue&type=template&id=1270f75d&"
import script from "./InfiniteScrollDetector.vue?vue&type=script&lang=js&"
export * from "./InfiniteScrollDetector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports